import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AuthenticationStore } from 'app/permission/services/authentication.store';

@Component({
  selector: 'pioneer-event-button-bar',
  templateUrl: './edit-event-button-bar.component.html'
})
export class EditEventButtonBarComponent {

  @Input()
  eventForm: FormGroup;

  @Input()
  isEventLockdown: boolean;

  @Input()
  isReadOnly: boolean;

  @Input()
  canBeDeleted: boolean;

  @Input()
  isMultiVendor: boolean;

  @Input()
  canBeUnmatched: boolean;

  @Input()
  isNotEditable: boolean;

  @Output()
  cancel = new EventEmitter();

  @Output()
  save = new EventEmitter();

  @Output()
  delete = new EventEmitter();

  @Output()
  edit = new EventEmitter();

  @Output()
  unmatch = new EventEmitter();

  constructor(
    private authenticationStore: AuthenticationStore
  ) { }

  cancelClick() {
    this.cancel.emit();
  }

  saveClick() {
    this.save.emit();
  }

  deleteClick() {
    this.delete.emit();
  }

  editClick() {
    this.edit.emit();
  }

  unmatchClick() {
    this.unmatch.emit();
  }

  public isSupportUser(): boolean {
    return this.authenticationStore.isSupportUser();
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/edit-event-button-bar/edit-event-button-bar.component.ts